class PollingService {
    constructor() {
      this.intervalId = null;
    }
    
    /**
     * Polling 시작
     * @param {Function} apiCall - API 호출 함수 (async function)
     * @param {Function} onUpdate - 업데이트 콜백 함수 (data) => void
     * @param {Function} shouldContinue - Polling 계속 여부 확인 함수 () => boolean
     * @param {number} interval - Polling 간격 (밀리초, 기본값: 3000)
     */
    startPolling(apiCall, onUpdate, shouldContinue, interval = 3000) {
      // 기존 polling 중지
      this.stopPolling();
      
      // 즉시 한 번 실행
      this.executePolling(apiCall, onUpdate, shouldContinue);
      
      // 주기적으로 실행
      this.intervalId = setInterval(() => {
        // shouldContinue가 false면 중지
        if (!shouldContinue()) {
          this.stopPolling();
          return;
        }
        
        this.executePolling(apiCall, onUpdate, shouldContinue);
      }, interval);
    }
    
    /**
     * Polling 실행 (내부 메서드)
     */
    async executePolling(apiCall, onUpdate, shouldContinue) {
      try {
        // shouldContinue가 false면 실행하지 않음
        if (!shouldContinue()) {
          this.stopPolling();
          return;
        }
        
        const data = await apiCall();
        onUpdate(data);
      } catch (error) {
        console.error('[PollingService] API 호출 오류:', error);
        // 에러 발생 시에도 polling은 계속 진행 (선택사항)
      }
    }
    
    /**
     * Polling 중지
     */
    stopPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    }
  }
  
// 싱글톤으로 export
export default new PollingService();